import React from 'react';
import { Task } from '../../../../../types/task';

interface TaskRecurrenceDisplayProps {
  task: Task;
  formatRecurrenceFrequency: (rrule: string | null) => string | null;
}

/**
 * 任务循环显示组件
 * 统一TaskItem和FocusTaskItem的循环任务显示
 */
export const TaskRecurrenceDisplay: React.FC<TaskRecurrenceDisplayProps> = ({
  task,
  formatRecurrenceFrequency
}) => {
  if (!task.recurrenceRule) return null;

  return (
    <div className="flex items-center mr-2 shrink-0">
      {/* 🔃圆润的刷新样式循环图标 */}
      <div className={`flex items-center ${task.isHabit ? 'text-ios-purple dark:text-ios-dark-purple' : 'text-ios-green dark:text-ios-dark-green'}`}>
        <svg className="w-3 h-3" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 8C13 10.7614 10.7614 13 8 13C5.23858 13 3 10.7614 3 8C3 5.23858 5.23858 3 8 3C9.5 3 10.8 3.7 11.6 4.8" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10 3L11.6 4.8L9.8 6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8C13 10.7614 10.7614 13 8 13C6.5 13 5.2 12.3 4.4 11.2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6 13L4.4 11.2L6.2 10" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        {/* 习惯标识 */}
        {task.isHabit && (
          <svg className="w-3 h-3 ml-0.5" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 1L8.5 5H13L9.5 8L11 12L7 9.5L3 12L4.5 8L1 5H5.5L7 1Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
      </div>

      {/* 频率文本 */}
      <span className={`text-ios-footnote ml-1 ${task.isHabit ? 'text-ios-purple dark:text-ios-dark-purple' : 'text-ios-green dark:text-ios-dark-green'}`}>
        {formatRecurrenceFrequency(task.recurrenceRule)}
      </span>
    </div>
  );
};
